module.exports = __webpack_public_path__ + "assets/media/your-gifts.4f31b285.svg";